
<div class="md:block hidden w-full">
  <button class="text-slate-800 dark:text-white focus:ring-0 focus:outline-none font-medium rounded-lg text-sm text-center
inline-flex items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false" (click)="toggleMenu()">
    <!-- <div class="lg:h-8 lg:w-8 h-7 w-7 rounded-full flex-1 ltr:mr-[10px] rtl:ml-[10px]">
        <img src="assets/images/all-img/user.png" alt="user" class="block w-full h-full object-cover rounded-full">
      </div> -->
    <span
      class="flex-none text-slate-600 dark:text-white text-sm font-normal items-center lg:flex hidden overflow-hidden text-ellipsis whitespace-nowrap">{{ globalHelper.currentUser.prenom }}
      {{ globalHelper.currentUser.nom }}</span>
   &nbsp;<i class="fal fa-chevron-down" ></i>
  </button>
  <!-- Dropdown menu -->
  <div class="dropdown-menu z-10  bg-white divide-y divide-slate-100 shadow w-44 dark:bg-slate-800 border dark:border-slate-700 !top-[23px] rounded-md
overflow-hidden" [class.hidden]="!menuDropdown">
    <ul class="py-1 text-sm text-slate-800 dark:text-slate-200">
      <!-- <li>
        <a [routerLink]="['/']" class="block px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-600 dark:hover:text-white font-inter text-sm text-slate-600
dark:text-white font-normal">
          <iconify-icon icon="heroicons-outline:user"
            class="relative top-[2px] text-lg ltr:mr-1 rtl:ml-1"></iconify-icon>
          <span class="font-Inter">Dashboard</span>
        </a>
      </li> -->
      <li>
        <a [routerLink]="['/auth/logout']" class="block px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-600 dark:hover:text-white font-inter text-sm text-slate-600
dark:text-white font-normal">
          <iconify-icon icon="heroicons-outline:login"
            class="relative top-[2px] text-lg ltr:mr-1 rtl:ml-1"></iconify-icon>
            <span class="font-Inter">Se déconnecter</span>
        </a>
      </li>
    </ul>
  </div>
</div>
